import { render, staticRenderFns } from "./ShareVariant.vue?vue&type=template&id=da799d74&"
import script from "./ShareVariant.vue?vue&type=script&lang=js&"
export * from "./ShareVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports